VerifyCtrl.$inject = ['$scope', 'verifiedUser'];

export default function VerifyCtrl($scope, verifiedUser) {
	$scope.verifiedUser = verifiedUser;
}



// WEBPACK FOOTER //
// ./project/pages/verify/verify.controller.js